import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { newsAPI } from '../services/api';
import './News.css';

const NewsDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNews();
  }, [id]);

  const fetchNews = async () => {
    setLoading(true);
    try {
      const res = await newsAPI.getOne(id);
      setNews(res.data);
    } catch (error) {
      console.error('获取新闻详情失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('zh-CN');
  };

  if (loading) {
    return (
      <div className="news-page">
        <section className="news-hero page-hero hero-tone-violet">
          <div className="page-hero-pattern"></div>
          <div className="container">
            <h1 className="page-title">加载中...</h1>
          </div>
        </section>
        <section className="content-section">
          <div className="container" style={{ textAlign: 'center', padding: '60px' }}>
            正在加载...
          </div>
        </section>
      </div>
    );
  }

  if (!news) {
    return (
      <div className="news-page">
        <section className="news-hero page-hero hero-tone-violet">
          <div className="page-hero-pattern"></div>
          <div className="container">
            <h1 className="page-title">信息发布</h1>
          </div>
        </section>
        <section className="content-section">
          <div className="container">
            <div className="news-card" style={{ textAlign: 'center', padding: '40px' }}>
              <p>信息不存在</p>
              <button className="btn btn-primary" onClick={() => navigate('/news')}>
                返回列表
              </button>
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="news-page">
      {/* Hero Section */}
      <section className="news-hero page-hero hero-tone-violet">
        <div className="page-hero-pattern"></div>
        <div className="container">
          <h1 className="page-title">信息发布</h1>
          <p className="page-subtitle">{news.tag}</p>
        </div>
      </section>

      {/* Content */}
      <section className="content-section">
        <div className="container">
          <div className="news-detail-card">
            <button className="back-btn" onClick={() => navigate('/news')}>
              ← 返回列表
            </button>

            <div className="news-detail-header">
              <span className="news-tag">{news.tag}</span>
              <span className="news-date">{formatDate(news.date)}</span>
            </div>

            <h1 className="news-detail-title">{news.title}</h1>

            <div className="news-detail-summary">
              <strong>简介：</strong>{news.summary}
            </div>

            <div
              className="news-detail-content rich-content"
              dangerouslySetInnerHTML={{ __html: news.content || '<p>暂无详细内容</p>' }}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default NewsDetail;